import React from "react";
import Joi from "joi-browser";
import Form from "../comman/form";
import auth from "../services/authService";
import { Link } from "react-router-dom";
import ForgetPassword from "./ForgetPassword";
import LoginStep1 from "./Auth/LoginStep1";
import LoginStep2 from "./Auth/LoginStep2";

class ApplicantLogin extends Form {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      step1: true,
      step2: false,
      userError: "",
    };
  }

  handleModalShowHide = () => {
    window.location.href = "/ForgotPassword";
  };

  handleStep1 = (step1Data) => {
    const { data } = this.state;
    const mergedData = { ...data, ...step1Data };
    this.setState({ step1: false, step2: true, data: mergedData });
  };

  handleDoSubmit = async (step2Data) => {
    const { data } = this.state;
    const mergedData = { ...data, ...step2Data };
    try {
      let usType = "partner";
      if (mergedData["userType"] === "Patient") usType = "applicant";
      await auth.login(
        mergedData.username,
        mergedData.password,
        usType,
        mergedData["partnerId"]
      );
      localStorage.setItem("userType", mergedData["userType"]);
      if (this.props.location.state !== undefined) {
        window.location = this.props.location.state.from.pathname;
      } else {
        if (data["userType"] === "Patient") window.location = "/PartnerLanding";
        else window.location = "/";
      }
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        this.setState({ userError: ex.response.data.message });
      }
    }
  };

  handleBack = () => {
    this.setState({ step2: false, step1: true });
  };

  render() {
    const { step1, step2, userError, data } = this.state;
    if (auth.getCurrentUser()) return <Link to="/" />;
    return (
      <div className="h-100 w-100">
        <div
          style={{
            backgroundColor: "white",
            textAlign: "left",
            borderBottom: "2px solid #ccc",
            backgroundColor: "#334132",
          }}
        >
          <img
            src="/assets/Images/Odva/OdvaHeader.png"
            alt=""
            style={{
              //objectFit: "cover",
              height: "70px",
              //width: "100%",
              //objectPosition: "left",
            }}
          />
        </div>
        <div className="main-content">
          <div className="col-md-12 text-center pb-2 pt-2">
            <h3 className="mb-0 text-black text-uppercase">
              Veteran Home Loan Origination System
            </h3>
          </div>

          <div
            className="col-md-12 text-center"
            style={{
              backgroundImage: `URL("/assets/Img/slide1.jpg")`,
              backgroundPosition: "center center",
              borderTop: "2px solid white",
              backgroundRepeat: "no-repeat",
              backgroundSize: "100%",
              color: "white",
              height: "150px",
            }}
          >
            <div
              class="home-slide-overlay"
              style={{ backgroundColor: "#3994fd" }}
            ></div>
          </div>
          <div
            className="col-md-12 text-center"
            style={{ position: "absolute", top: "100px" }}
          >
            <h1 className="text-white text-uppercase">
              GATEWAY ACCESS TO ODVA Partner
            </h1>
          </div>

          <div className="container mt-5">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-10">
                <div
                  className="card shadow-none border"
                  style={{ backgroundColor: "#fafafa" }}
                >
                  <div className="card-body text-center p-2">
                    <h2 className="mb-0">
                      Oregon Department of Veterans Affairs (ODVA)
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div
                  className="card shadow-none border"
                  style={{ backgroundColor: "#fafafa", height: "95%" }}
                >
                  <div className="card-body text-center">
                    <b>
                      Welcome to WorkFINITY® Network of Partner Management
                      System
                    </b>
                    <p>
                      For any help, please contact Ric Johnson, WorkFINITY®
                      Administrator at ricj@workfinity.com or by phone (952)
                      541-4777
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div
                  className="card shadow-none border"
                  style={{ backgroundColor: "#fafafa", height: "95%" }}
                >
                  <div className="card-body">
                    <div className="text-center text-white mb-2">
                      <h3 className="text-black">Sign In</h3>
                    </div>
                    {step1 && (
                      <LoginStep1
                        handleStep1={this.handleStep1}
                        userError={userError}
                      ></LoginStep1>
                    )}
                    {step2 && (
                      <React.Fragment>
                        <div>
                          <button
                            className="btn btn-link btn-sm"
                            onClick={this.handleBack}
                          >
                            <i
                              className="fa fa-long-arrow-left"
                              aria-hidden="true"
                            ></i>
                            Back
                          </button>
                        </div>
                        <div>
                          <label className="form-control-label">
                            User Type : {data["userType"]}, Valid ID :{" "}
                            {data["partnerId"]}
                          </label>
                        </div>
                        <LoginStep2
                          handleDoSubmit={this.handleDoSubmit}
                          userError={userError}
                        ></LoginStep2>
                      </React.Fragment>
                    )}
                    <div className="mt-2">
                      <input
                        className="checkbox mr-2 mt-1"
                        id=" customCheckLogin"
                        type="checkbox"
                      />
                      <label htmlFor="customCheckLogin">Remember me</label>
                      {step2 && (
                        <a
                          href="/ForgotPassword"
                          className="btn btn-link btn-sm"
                          style={{ float: "right" }}
                        >
                          Forgot Password?
                        </a>
                      )}
                      {step1 && (
                        <a
                          href="/ForgotValidID"
                          className="btn btn-link btn-sm"
                          style={{ float: "right" }}
                        >
                          Forgot Your ID?
                        </a>
                      )}
                      <ForgetPassword
                        showHide={this.state.showHide}
                        handleModalShowHide={this.handleModalShowHide}
                      ></ForgetPassword>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-10">
                <div
                  className="card shadow-none border"
                  style={{ backgroundColor: "#fafafa" }}
                >
                  <div className="card-body text-center p-2">
                    <p>
                      Support: Phone: 1-877-515-3333 Email:{" "}
                      <a href="mailto:support@workfinity.com">
                        Support@workfinity.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12" style={{ backgroundColor: "#2b62a1" }}>
            <div className="container pt-3 pb-3">
              <div className="row">
                <div className="col-md-2 text-white">
                  <img src="/assets/Img/logo_ft.png" />
                  <br />
                  Delivered by IPCS &reg;
                </div>
                <div className="col-md-8 text-white text-center">
                  This software is licensed to the user. Use of the software
                  constitutes acceptance of the terms and conditions of the
                  License Agreement @IPCS®. @WorkFinity®.
                  <br />
                  All rights reserved.
                  <br />
                  Under US Patent Protection
                </div>
                <div className="col-md-2 text-white"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ApplicantLogin;
